export const EVENT_MESSAGE = {
  JOIN_COMPLETED: "Join confirmed.\nPlease check on My Page!",
  JOIN_ERROR: "",
  JOIN_CANCELLED: "Participation canceled.",
  JOIN_CANCEL_ERROR: "",
  SHARE_LINK: "Copied to the clipboard.",
  DUPLICATE_JOIN:
    "Please cancel your participation in the Enkoplay event scheduled for this time and rejoin!",
};

export const COMMENT_MESSAGE = {
  COMMENT_ADDED: "Comment added.",
  COMMENT_EDITED: "Comment edited.",
  COMMENT_DELETED: "Comment deleted.",
  REPLY_ADDED: "Reply added.",
  REPLY_EDITED: "Reply edited.",
  REPLY_DELETED: "Reply deleted.",
};
